import BaseApi from "../../../services/baseApi";

class Reporting {
    constructor() {
        this.entity = 'remainingReport';
    }

    getPage() {
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            url: '/private/'+this.entity+'/list/',
            headers: {'Content-Type': 'application/json'},
        })
    }
    getBuildingItems( buildingId) {
        let formData=new FormData();
        formData.set("buildingId",buildingId)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data:formData,
            url: '/private/'+this.entity+'/getBuildingItems/',
            headers: {'Content-Type': 'application/json'},
        })
    }

    search(model){
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data:model,
            url: '/private/'+this.entity+'/search',
            headers: {'Content-Type': 'application/json'},
        })

     }
    sendMap(map){
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data:map,
            url: '/private/'+this.entity+'/sendMap',
            headers: {'Content-Type': 'application/json'},
        })

     }
    getTemplateSms(bId)
    {
        return BaseApi({requiresAtuh: true})({
            method: 'GET',
            url: '/private/templateSmsManager/getTemplateSms?bId='+bId,
            headers: {'Content-Type': 'application/json'},
        })

     }

    reportExcel(model) {
        return BaseApi({requiresAtuh: true})({
            showLoader: false,
            method: 'POST',
            data: model,
            url: '/private/' + this.entity + '/search',
            headers: {'Content-Type': 'application/json'},
            responseType: 'blob', // important
        })
    }

}
export default new Reporting();
